/**
* @Author: zachalam
* @Date:   2017-03-15T16:25:42-07:00
* @Email:  zach@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T11:42:50-07:00
*/


import React, { Component } from 'react';

import { StyleSheet, css } from 'aphrodite/no-important';
// import { spacing, dimensions, color } from '../../../style';
import Modal from '../../common/Modal';

const style = StyleSheet.create({

  photoTile: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '3px'
  },

  // Base photo btn
  photoBtn: {
    backgroundColor: 'rgba(0,0,0,0.58)',
    padding: '7px 10px',
    borderRadius: '25px',
    display: 'inline-block',
    color: '#fff',
    whiteSpace: 'nowrap',
    boxShadow: `0 0 0 2px rgba(255,255,255,0.65)`
  },

  isHighlighted: {
    color: '#ffd980'
  },

  // overlay container for photos and option buttons
  fitToEdges: {
    height: '100%',
    width: '100%',
    userSelect: 'none',
    position: 'absolute',
    left: '0',
    top: '0'
  },

  //Hover state to hide and show button overlay
  hover: {
    visibiilty: 'hidden',
    opacity: 0,

    ':hover': {
      visibiilty: 'visibiilty',
      opacity: 1,
    }
  },

  // Options Buttons positioning

  photoPreview_deleteBtn: {
    position: 'absolute',
    top: 10,
    left: 10
  },

  photoPreview_lockBtn: {
    position: 'absolute',
    top: 10,
    right: 10
  },

  photoPreview_profileBtn: {
    position: 'absolute',
    bottom: 10,
    left: '50%',
    transform: 'translateX(-50%)'
  },

  photoContainer: {
    display: 'block',
    overflow: 'hidden',
    paddingBottom: '100%',
    position: 'relative',
  }
})

class UserPhoto extends Component {

  constructor(props) {
    super(props);
    this.photoOptions = this.photoOptions.bind(this);
    this.is_touch_device = this.is_touch_device.bind(this);

  }

  profilePhotoBtn(photo, key) {
      if(photo.is_avatar) {
        return (
          <div className={css(style.photoPreview_profileBtn)}>
            <b className={css(style.photoBtn, style.isHighlighted)}>Profile Photo</b>
          </div>
        )
      } else {
        return (
          <div className={css(style.photoBtn)} onClick={(e) => { e.preventDefault(); this.props.makeDefault(photo.id, key) }}>
            Make Profile Photo</div>
        )
      }
  }

  photoOptions() {
    let { photo, theKey } = this.props;
    let key = theKey;

    let deletePhotoTxt = <div className={css(style.photoBtn)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" fill="#fff" viewBox="0 0 13 17">
        <g>
          <path d="M11.4855 3L9.96623333 3 9.96623333 1.4464256C9.96623333.647183803 9.29305 0 8.463 0L4.537 0C3.70695 0 3.03376667.647183803 3.03376667 1.4464256L3.03376667 3 1.5145 3C.682716667 3 0 3.31136477 0 4 0 4.68571905.682716667 5 1.5145 5L11.4855 5C12.3172833 5 13 4.68571905 13 4 13 3.31136477 12.3172833 3 11.4855 3zM3.93553333 1.4464256C3.93553333 1.12835361 4.20593333.867980337 4.537.867980337L8.463.867980337C8.79406667.867980337 9.06446667 1.12835361 9.06446667 1.4464256L9.06446667 2.99944196 3.93553333 2.99944196 3.93553333 1.4464256zM1 14.9432115C1 16.0789615 1.99831278 17 3.2278162 17L9.7721838 17C11.0014581 17 12 16.0789615 12 14.9432115L12 6 1 6 1 14.9432115zM8.82336277 7.2984375L10.1234378 7.2984375 10.1234378 14.3936485C10.1234378 14.7276339 9.83198634 15 9.47271288 15 9.11504333 15 8.82336277 14.7276339 8.82336277 14.3936485L8.82336277 7.2984375zM5.84560907 7.2984375L7.14385102 7.2984375 7.14385102 14.3936485C7.14385102 14.7276339 6.8523996 15 6.49450092 15 6.13568572 15 5.84560907 14.7276339 5.84560907 14.3936485L5.84560907 7.2984375zM2.86602233 7.2984375L4.16426429 7.2984375 4.16426429 14.3936485C4.16426429 14.7276339 3.87441676 15 3.51674721 15 3.15793201 15 2.86602233 14.7276339 2.86602233 14.3936485L2.86602233 7.2984375z"/>
        </g> &nbsp; Delete Photo
      </svg>
    </div>

    //console.log("photo options ran");

      // not default photo
      return (
        <span className={css(style.fitToEdges, !this.is_touch_device() && style.hover)}>
          <div className={css(style.photoPreview_profileBtn)}>
            {this.profilePhotoBtn(photo, key)}
          </div>

          <div className={css(style.photoPreview_lockBtn)}>
            <div className={css(style.photoBtn)} onClick={(e) => { e.preventDefault(); this.props.setPrivacy(photo.id,key) }}>
              {photo.private === true ? 'Private' : 'Public'}
            </div>
          </div>

        <div className={css(style.photoPreview_deleteBtn)}>
          <Modal linkText={deletePhotoTxt}
            yesCallback={() => {this.props.deletePhoto(photo.id,key)}}
            yesBtn='Delete'
            noBtn='Cancel'>
            {/* <Title>Delete this picture?</Title> */}
            <p>Are you sure? Deleting this picture will remove it from your profile.</p>
          </Modal>
        </div>
        </span>
      );

  }

  is_touch_device() {

     return (('ontouchstart' in window)
        || (navigator.MaxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0));
  }

  render() {

    return (
      <div className={css(style.photoTile)}>
        <div className={css(style.photoContainer)}>
          <img className={css(style.fitToEdges)} src={this.props.thumb} />
        </div>
        {this.photoOptions()}
      </div>
    );
  }
}



export default UserPhoto;



// WEBPACK FOOTER //
// ./src/components/pages/Photos/UserPhoto.jsx